/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PersonPreferenceInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class PersonPreferenceApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'PersonPreferences');
  }

  find(params?: Record<string, any>): Observable<PersonPreferenceInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<PersonPreferenceInterface[]>(path, httpParams);
  }

  deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<boolean>(path).pipe(map(() => true));
  }

  upsertPersonPreference(personPreference: Partial<PersonPreferenceInterface>): Observable<PersonPreferenceInterface> {
    const path = `upsert-person-preference`;
    const body = personPreference;
    return this.post<PersonPreferenceInterface>(path, undefined, body);
  }
}
